// extracted by mini-css-extract-plugin
export var center = "m_Q";
export var content = "m_M";
export var fromLeft = "m_R";
export var fromLeftRev = "m_T";
export var isClosing = "m_K";
export var left = "m_J";
export var modal = "m_H";
export var opacity = "m_P";
export var opacityRev = "m_S";
export var opened = "m_N";
export var overlay = "m_L";